import { defineComponent as n, openBlock as t, createBlock as r, unref as p, mergeProps as d, withCtx as u, createElementVNode as e } from "vue";
import { RevIcon as i } from "@ds/components/Icon";
const f = /* @__PURE__ */ n({
  name: "IconPeople",
  __name: "IconPeople",
  props: {
    size: {},
    alternativeText: {}
  },
  setup(a) {
    const o = a;
    return (m, l) => (t(), r(p(i), d(o, { "view-box": "0 0 24 24" }), {
      default: u(() => [...l[0] || (l[0] = [
        e("path", {
          "fill-rule": "evenodd",
          d: "M17 4.5a3.25 3.25 0 1 0 0 6.5 3.25 3.25 0 0 0 0-6.5m-1.75 3.25a1.75 1.75 0 1 1 3.5 0 1.75 1.75 0 0 1-3.5 0",
          "clip-rule": "evenodd"
        }, null, -1),
        e("path", { d: "M15.536 11.5a3.25 3.25 0 0 0-2.299.952L12.97 12.72a.75.75 0 1 0 1.06 1.06l.268-.267A1.75 1.75 0 0 1 15.536 13h2.929a1.75 1.75 0 0 1 1.237.513l.06.06a1.66 1.66 0 0 1 .488 1.177.75.75 0 0 0 1.5 0 3.16 3.16 0 0 0-.927-2.237l-.06-.061a3.25 3.25 0 0 0-2.299-.952h-2.928" }, null, -1),
        e("path", {
          "fill-rule": "evenodd",
          d: "M4.5 9a4 4 0 1 1 8 0 4 4 0 0 1-8 0m4-2.5a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5",
          "clip-rule": "evenodd"
        }, null, -1),
        e("path", { d: "M6.414 14a4.164 4.164 0 0 0-4.164 4.164v.586a.75.75 0 0 0 1.5 0v-.586A2.664 2.664 0 0 1 6.414 15.5h4.172a2.664 2.664 0 0 1 2.664 2.664v.586a.75.75 0 0 0 1.5 0v-.586A4.164 4.164 0 0 0 10.586 14H6.414" }, null, -1)
      ])]),
      _: 1
    }, 16));
  }
});
export {
  f as default
};
